import { styled } from '@creditas-ui/system';
import { Flex } from '@creditas-ui/layout';
import { media, prop } from '@creditas-ui/utilities';

const Container = styled(Flex)`
  flex: 1;
  box-sizing: border-box;
  overflow-y: auto;
  scroll-behavior: smooth;
  padding: 0 ${prop('theme.spacingX.5xl')} 0 ${prop('theme.spacingX.7xl')};
  flex-direction: column;

  & > div {
    height: 100%;
    box-sizing: border-box;
  }

  ${media.up('4xl')} {
    padding: 0 ${prop('theme.spacingX.12xl')} 0 ${prop('theme.spacingX.14xl')};
  }
`;

export { Container };
